import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Form, Input, Button, Checkbox } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useUser } from "../../context/UserContext";
import userService from "../../services/userService";
import { useNotify } from "../../context/NotificationContext";

// Removed unused Typography components

const Login = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useUser();
  const notify = useNotify();

  const onFinish = async (values) => {
    try {
      setLoading(true);

      const { email, password } = values;

      // Call login API
      const response = await userService.login({
        email,
        password,
      });

      console.log("login response", response);

      const { data } = response;

      if (data && data.status) {
        // Store token in localStorage (similar to Vue cookie)
        const token = data.token;
        const user = data.user;

        // Prepare user data for context
        const userData = {
          name: user.firstname,
          avatar: "@AVATAR",
          address: "Mumbai",
          welcome: "Welcome",
          timefix: `Date: ${new Date().toLocaleDateString("en-GB")}`,
          ...user,
        };

        // Login user through context
        await login({
          token,
          user: userData,
        });

        // Show success notification
        notify.success({
          message: "Login Successful",
          description: data.message,
        });

        // Navigate to dashboard
        navigate("/dashboard");
      } else {
        console.log("login failed", data);
        notify.error({
          message: "Login Failed",
          description: data.message,
        });
      }
    } catch (error) {
      console.error("Login error:", error);
      notify.error({
        message: "Login Failed",
        description: "Please enter valid email and password",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-zinc-100">
      <Card className="w-96 flex flex-col">
        <h1 className="text-2xl font-medium mb-10 text-center">Login to your account</h1>
        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          layout="vertical"
          size="large"
          initialValues={{
            remember: true,
          }}
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Please input your email!" },
              { type: "email", message: "Please enter a valid email!" },
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="Enter email" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please input your Password!" }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Enter password"
            />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>Remember me</Checkbox>
          </Form.Item>

          <Form.Item>
            <Button loading={loading} type="primary" htmlType="submit" block>
              Login
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
